var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.svg)?_c('span',{staticClass:"ux-icon ux-icon--svg",attrs:{"aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.svg)}}):(_vm.mdi)?_c('v-icon',{staticClass:"ux-icon ux-icon--mdi"},[_vm._v(_vm._s(_vm.mdi))]):_c('span',{staticClass:"ux-icon"},[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }